import feature1 from "../assets/feature-1.png";
import feature2 from "../assets/feature-2.png";
import feature3 from "../assets/feature-3.png";
import feature4 from "../assets/feature-4.png";
import feature5 from "../assets/feature-5.png";
import feature6 from "../assets/feature-6.png";
import feature7 from "../assets/feature-7.png";

export const pricingContent = [
  {
    header: {
      label: "Free",
      title: "$0",
      description: "",
    },
    section: [
      { initial: "750mb", rest: "Max file storage" },
      { initial: "24 hours", rest: "Available session recording" },
      { initial: "Limited", rest: "Analytics and Report" },
    ],
    button: { title: "SIGN UP", plan: "free" },
    isOpen: true,
  },
  {
    header: {
      label: "Pro",
      title: "$399",
      description: "",
    },
    section: [
      { initial: "5gb", rest: "Max file storage" },
      { initial: "7 days", rest: "Available session recording" },
      { initial: "Advanced", rest: "Analytics and Report" },
    ],
    button: { title: "BUY NOW", plan: "lite" },
    isOpen: false,
  },
  {
    header: {
      label: "Elite",
      title: "$599",
      description: "",
    },
    section: [
      { initial: "15gb", rest: "Max file storage" },
      { initial: "30 days", rest: "Available session recording" },
      { initial: "Advanced", rest: "Analytics and Report" },
    ],
    button: { title: "BUY NOW", plan: "pro" },
    isOpen: false,
  },
  {
    header: {
      label: "Custom",
      title: "Let's Talk",
      description: "",
    },
    section: [
      { initial: "Customized", rest: "Learning format based on your needs" },
      {
        initial: "Get in touch",
        rest: "with our sales team today for your custom pricing quotes",
      },
    ],
    button: { title: "CONTACT NOW", plan: "custom" },
    isOpen: false,
  },
];

export const pricingFeatures = [
  {
    description: "Maxuser accounts",
    tootip:
      " Unlimited users (users - students, admin, instructors) can be added per account",
  },
  {
    description: "Virtual classroom per session",
    tootip: "Instructors/Admins can host unlimited virtual classroom/webinars",
  },
  {
    description: "Total virtual sessions per day",
    tootip: "Unlimited session length-recording available for 24 hrs",
  },
  {
    description: "Upload video course files",
    tootip: "No limit for adding courses or content",
  },
  { description: "Webinar recording", tootip: "Full length webinar recording" },
  {
    description: "Unlimited courses and activities",
    tootip: "No limit for adding courses or content",
  },
  {
    description: "Max concurrent video conferencing",
    tootip: " Unlimited users per video/webinar session",
  },
  
];

export const featuresIcons = [
  feature1,
  feature2,
  feature3,
  feature4,
  feature5,
  feature6,
  feature7,
];

export const addonPlans = {
  languisity: [
    {
      price: 599,
      description: "One time + Per Account",
    },
    {
      price: 225,
      description: "Per hour of Customization",
    },
  ],
  admin: [
    {
      price: 599,
      description: "One time + Per Account",
    },
    {
      price: 225,
      description: "Per hour of Customization",
    },
  ],
};

export const faqs = [
  {
    question: "Do I need a credit card to sign up?",
    answer:
      "No credit card is required. Start on our free plan today and start designing your courses for free.",
  },
  {
    question: "Can I cancel or change my plan at any time?",
    answer:
      "Yes. You can upgrade or downgrade your account at any time from within your site dashboard.",
  },
  {
    question: "Do I own my own content?",
    answer:
      "Absolutely! You always own your student data and your content. We’ll never market to your students, and you can export your data at any time.",
  },
  {
    question: "What support is included to help me get started?",
    answer:
      "Our customer support team can be reached via email at support@yslearn.com or by phone at the toll free number (855) 200-6309.",
  },
  {
    question: "Are all the payments in USD?",
    answer: "We accept payments in local currencies where possible.",
  },
  {
    question: "When I apply a promo code it says the code is no longer valid?",
    answer:
      "Please reach out to technicalsupport@yslearn.com for help. Our technical team will make sure your problems are resolved promptly.",
  },
  {
    question:
      "Do I need to pay extra to make my course visible/Popular on the yslearn homepage?",
    answer: "Currently we do not offer this option.",
  },
  {
    question: "Is it possible to share my account with another Instructor?",
    answer:
      "We would not recommend doing so due to internet security and privacy concerns with a shared account. ",
  },
  {
    question: "Can I use my Paypal account?",
    answer:
      "We offer Visa, Master, Amex as well as most of the cards. We are working on adding Paypal as a payment option.",
  },
  {
    question: "What is the cancellation, policy?",
    answer:
      "Please refer to the “Payment and Refund Policy” by clicking “Terms” in the footer at the bottom of the page.",
  },
  {
    question: " Will I get a tax invoice?",
    answer:
      "If you are a resident of Canada, the appropriate tax portion will be calculated based on your province and added to your invoice. ",
  },
];
